import { useTranslation } from "@i18n/hooks";

type OwnProps = {
	children: any;
};

export const BaseContentEditor = ({ children }: OwnProps) => {
	const { t } = useTranslation("common");
	return (
		<div>
			<div className="flex align-items-center">
				<h2>{t("general.elements")}</h2>
			</div>
			{children}
		</div>
	);
};
